<template>
  <div class="otp-wrapper">
    <div class="input-label">
      {{ $t("message.signUp.basicBlock.otp.title") }}
    </div>
    <div class="otp-block">
      <base-text-input
        @input="emitValue"
        :name="'otp'"
        :disabled="disabled"
        :type="'number'"
      />
    </div>
    <div class="input-error-block send-otp-block" @click="getOtpCode()">
      {{ $t("message.signUp.basicBlock.otp.sendOtp") }}
    </div>
  </div>
</template>

<script>
import BaseTextInput from './BaseTextInput.vue';

export default {
  name: 'BaseOtpInput',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BaseTextInput
  },
  methods: {
    emitValue(value) {
      this.$emit('input', value);
    },
    getOtpCode() {
      if (!this.disabled) {
        return this.$emit('getOtpCode');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.otp-wrapper {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.input-label {
  @include base-input-label;
}

.otp-block {
  width: 50%;
  height: 54px;
  border-radius: var(--base-input-border-radius);
}

.send-otp-block {
  margin-top: 3px;
  font-weight: 400;
  font-size: 16px;
  line-height: 135%;
  letter-spacing: 0.01em;
  text-decoration-line: underline;
  color: #41BF7B;
  cursor: pointer;
  font-family: 'Open Sans';
  user-select: none;
}

.input-error-block {
  @include base-input-error-block;
}
</style>